import { LOGOUT, SAVE_USER } from "../actions/user";

const initialState = {
  user: null,
  loading: true,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USER: {
      const { user } = action;
      return {
        ...state,
        ...user,
        loading: false,
      };
    }
    case LOGOUT: {
      return {
        user: null,
        loading: false,
      };
    }

    default: {
      return state;
    }
  }
};
